import { render, staticRenderFns } from "./SPUcar.vue?vue&type=template&id=56a19816&scoped=true"
import script from "./SPUcar.vue?vue&type=script&lang=ts"
export * from "./SPUcar.vue?vue&type=script&lang=ts"
import style0 from "./SPUcar.vue?vue&type=style&index=0&id=56a19816&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a19816",
  null
  
)

export default component.exports